import type { EditableImageListRecord } from '../../types/index.ts';
import type {
  EditableImageListProps,
  UseEditableImageListOptions
} from '../EditableImageList/index.ts';
import { useEffect, useEffectEvent, useState } from 'react';
import { EditableImageList, useEditableImageList } from '../EditableImageList/index.ts';

export type MultiImageUploaderProps = Pick<
  EditableImageListProps,
  'renderImage' | 'renderPlaceholder' | 'renderUploadButtonContainer'
> &
  Pick<UseEditableImageListOptions, 'onUploadFile'> & {
    disabled?: boolean;
    maxImages: number;
    onChange: (value: EditableImageListRecord[]) => void;
    value: EditableImageListRecord[];
  };

export function MultiImageUploader({
  disabled,
  maxImages,
  onChange,
  onUploadFile,
  value,
  ...imageListProps
}: MultiImageUploaderProps) {
  const [initialItems] = useState<EditableImageListRecord[]>(() => value);

  const imageList = useEditableImageList({
    initialItems,
    maxImages,
    onUploadFile
  });

  const triggerOnChange = useEffectEvent(() => {
    onChange(imageList.currentItems);
  });

  useEffect(() => {
    triggerOnChange();
  }, [imageList.currentItems]);

  return (
    <div className="flex min-h-60 flex-col">
      <EditableImageList
        disabled={disabled}
        editing
        items={imageList.currentItems}
        maxImages={maxImages}
        {...imageListProps}
        {...imageList.listeners}
      />
    </div>
  );
}
